import { render, staticRenderFns } from "./RobotsSetting.vue?vue&type=template&id=b22f44b4&"
import script from "./RobotsSetting.vue?vue&type=script&lang=js&"
export * from "./RobotsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports